import { buildCharacterWorldProps } from './buildCharacterWorldProps';
import { buildContestInfoProps } from './buildContestInfoProps';
import { isStudent, isRegisteredTeacher, isContestStage, isUnregisteredTeacher, isNotRegistered, isIdentified, itIsMyCompetition, isCompetitionEnded, isHideDuringYearTransition } from './utils';
import { isCharedi } from '../../utils/utils';
import { buildCompetitionStatusProps } from './buildCompetitionStatusProps';
import { buildFinalSectionProps } from './buildFinalSectionProps';
import { buildScoreboardProps } from './buildScoreboardProps';

export const buildTabsConfig = (state, authState) => {
  const tabDefinitions = [
    {
      id: 'competitionStatus',
      title: 'toCompetitionLink',
      shouldShow: () => {
        return true;
      },
      sectionsBuilder: (state, authState) => {
        return [
          {
            id: 'competition-status-section',
            type: 'CompetitionStatus',
            anchorId: 'competition-status-section',
            props: buildCompetitionStatusProps(state, authState),
            show: itIsMyCompetition(state, authState)
          },
          {
            id: 'final-section',
            type: 'FinalSection',
            anchorId: 'final-section',
            props: buildFinalSectionProps(state, authState),
            show: isCompetitionEnded(state)
          },
        ];
      },
      titleOverride: (state, authState) => {
        if (!isIdentified(authState)) {
          return "tabTitleIsUnidentified";
        }
        // תלמיד לא רשום אחרי שהתחרות התחילה
        if (isStudent(state) && isNotRegistered(state) && isContestStage(state)) {
          return "myStars";
        }

        // מורה רשום לפני שהתחרות התחילה
        if (isRegisteredTeacher(state) && !isContestStage(state)) {
          return "toCompetitionLink";
        }
        if (isUnregisteredTeacher(state) && isContestStage(state)) {
          return "toCompetitionLink";
        }
        // אם אתה כבר נמצאים בשלב התחרות לא משנה מי (כל המקרים האחרים)
        if (isContestStage(state)) {
          return "myStars";
        }

        return null; // אין דריסה - משתמש בכותרת ברירת מחדל 'scoreboard'
      }

    },
    {
      id: 'scoreboard',
      title: 'scoreboard',
      shouldShow: (state, authState) => {
        return isContestStage(state);
      },

      sectionsBuilder: (state, authState) => {
        return [
          {
            id: 'scoreboard-section',
            type: 'Scoreboard',
            anchorId: 'scoreboard-section',
            props: buildScoreboardProps(state, authState),
          },
        ];
      },
    },
    {
      id: 'character-world',
      title: 'worldOfScientists',
      shouldShow: (state, authState) => {
        return !isCharedi();
      },
      sectionsBuilder: (state, authState) => {
        return [
          {
            id: 'character-world-section',
            type: 'CharacterWorld',
            anchorId: 'character-world-section',
            props: buildCharacterWorldProps(state, authState),
          },
        ];
      },
    },
    {
      id: 'competitionInformation',
      title: 'competitionInformation',
      shouldShow: (state, authState) => {
        // תמיד מוצג
        return true;
      },
      titleOverride: null, // אין דריסת כותרת
      sectionsBuilder: (state, authState) => {
        return [
          {
            id: 'contest-info-section',
            type: 'ContestInfo',
            anchorId: 'contest-info-section',
            props: buildContestInfoProps(state, authState),
          },
        ];
      },

    },
  ];

  return tabDefinitions;
};

